import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  linkActiveClass:'active',
  scrollBehavior (to, from, savedPosition) {  //设置跳转到新页面顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: (resolve) => require(['@/pages/Index'], resolve),
			meta: {
				title:'Live Radio, Shows & Podcasts | CGTN Radio',
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/special',
      name: 'Special',
      component: (resolve) => require(['@/pages/Special'], resolve),
			meta: {
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podcast',
      name: 'Podcast',
      component: (resolve) => require(['@/pages/Podcast'], resolve),
			meta: {
				title:'Shows & Podcasts | CGTN Radio',
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/francais',
      name: 'Francais',
      component: (resolve) => require(['@/pages/Francais'], resolve),
			meta: {
				title:'Francais | CGTN Radio',
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/shows/:newsId',
      name: 'Shows',
      component: (resolve) => require(['@/pages/Shows'], resolve),
			meta: {
				title:'Radio - CGTN',
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podcast/columngroup/:pColumnName/:pColumnId',
      name: 'PodcastList',
      component: (resolve) => require(['@/pages/PodcastList'], resolve),
			meta: {
				title:'Radio - CGTN',
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/newslist/:newsTitle/:newsId',
      name: 'NewsList',
      component: (resolve) => require(['@/pages/NewsList'], resolve),
			meta: {
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/news/:newsType/:newsTitle/:newsId',
      name: 'NewsDetail',
      component: (resolve) => require(['@/pages/NewsDetail'], resolve),
			meta: {
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podcast/news/:programType/:programTitle/:programId',
      name: 'PodcastDetail',
      component: (resolve) => require(['@/pages/PodcastDetail'], resolve),
			meta: {
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podcast/column/:programType/:programTitle/:programId',
      name: 'PodcastColumn',
      component: (resolve) => require(['@/pages/PodcastColumn'], resolve),
			meta: {
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podfest',
      name: 'Podfest',
      component: (resolve) => require(['@/pages/podfest'], resolve),
			meta: {
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
    {
      path: '/podfest/FAQs',
      name: 'PodfestDetail',
      component: (resolve) => require(['@/pages/podfestDetail'], resolve),
			meta: {
				keepAlive:true,
				isplayer:true,
				isFooterMargin:true,
				isHeader:true,
			}
    },
	{
	  path: '/WhyWeLoveDunhuang',
	  name: 'Dunhuang',
	  component: (resolve) => require(['@/special/dunhuang'], resolve),
		meta: {
			keepAlive:true,
			isplayer:false,
			isFooterMargin:false,
			isHeader:true,
		}
	},
  	{
	  path: '/special/Stories-of-Xi-Jinping',
	  name: 'Xjpdgs',
	  component: (resolve) => require(['@/special/xjpdgs'], resolve),
		meta: {
			keepAlive:true,
			isplayer:false,
			isFooterMargin:false,
			isHeader:true,
		}
	},
	{
		path: '/special/my-expat-life-in-rural-china',
		name: 'ruralChina',
		component: (resolve) => require(['@/special/ruralChina'], resolve),
		  meta: {
			  keepAlive:true,
			  isplayer:false,
			  isFooterMargin:false,
			  isHeader:true,
		}
	},
	{
		path: '/special/Chinese-Folk-Tales',
		name: 'folkTales',
		component: (resolve) => require(['@/special/folkTales'], resolve),
		  meta: {
			title:'Chinese Folk Tales',
			  keepAlive:true,
			  isplayer:false,
			  isFooterMargin:false,
			  isHeader:true,
		}
	},
	{
		path: '/special/The-Yellow-River-Mosaic',
		name: 'huanghe',
		component: (resolve) => require(['@/special/huanghe'], resolve),
		  meta: {
			title:'The-Yellow-River-Mosaic',
			keepAlive:true,
			isplayer:false,
			isFooterMargin:false,
			isHeader:true,
		}
	},
	// {
	// 	path: '/special/diy',
	// 	name: 'specialDiy',
	// 	component: (resolve) => require(['@/special/diy'], resolve),
	// 	  meta: {
	// 		title:'specialDiy',
	// 		  keepAlive:true,
	// 		  isplayer:false,
	// 		  isFooterMargin:false,
	// 		  isHeader:true,
	// 	}
	// },
    {
      path: '*',
      redirect: '/',
      meta: {}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js